// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_SIZE_OTHER = "Jin\u00e1";
export const BZ2_FACET_P_ISOFIX = "Isofix";
export const BZ2_FACET_P_LENGTH_ORDINAL = "D\u00e9lka (cm)";
export const BZ2_FACET_P_WIDTH_ORDINAL = "\u0160\u00ed\u0159ka (cm)";
export const COMMON_PLACES_ABROAD = "Zahrani\u010d\u00ed";
